module.exports = __webpack_public_path__ + "img/accessible.d49c241f.svg";